import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "content", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `financials--books--dashboards--clients--dashboard`
  }

  doClientsDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-12 px-0" data-${this.controllerName}-target="content" data-controller="financials--books--clients--entities--index
                                                                                                         financials--books--dashboards--clients--show
                                                                                                         financials--books--clients--entities--save
                                                                                                         financials--books--clients--contracts--save"></div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`financials--books--dashboards--main--page`).settingsTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier("financials--books--clients--entities--index").permission = `financial_settings_clients`
      controller.getControllerByIdentifier("financials--books--clients--entities--index").controllerDashboard = this.getControllerByIdentifier(`financials--books--dashboards--clients--dashboard`)
      controller.getControllerByIdentifier("financials--books--clients--entities--index").gridElement = this.getControllerByIdentifier(`financials--books--dashboards--clients--dashboard`).contentTarget
      controller.getControllerByIdentifier("financials--books--clients--entities--index").doClientList()

      controller.getControllerByIdentifier("financials--books--clients--entities--save").permission = `financial_settings_clients`
      controller.getControllerByIdentifier("financials--books--clients--entities--save").gridElement = controller.contentTarget
      
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
